export default __webpack_public_path__ + "static/media/cabello-mujer-verde.37b9a792.png";